export default "__VITE_ASSET__CjULtOF2__"